import styled from "styled-components";

import { motion } from "framer-motion";

export const ModalSectionBody = styled.div.attrs({
  className: "fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-8",
})``;

export const ModalSectionHeader = styled.div.attrs({
  className:
    "flex items-start justify-between gap-4 border-b border-[var(--brand-border)] px-4 py-4 sm:px-5",
})``;

export const ModalContentStack = styled.div.attrs({ className: "min-w-0 space-y-1.5" })``;

export const ModalEyebrowText = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.24em] text-[var(--brand-highlight)]",
})``;

export const ModalSectionHeading = styled.h2.attrs({
  className: "break-words text-xl font-semibold text-[var(--brand-ink)] sm:text-2xl",
})``;

export const ModalBodyText = styled.p.attrs({
  className: "mt-2 max-w-2xl text-[13px] leading-6 text-[var(--brand-muted)]",
})``;

export const ModalIconButton = styled.button.attrs({
  className:
    "flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.05)] text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)]",
})``;

export const ModalScrollArea = styled.div.attrs({
  className: "flex-1 overflow-y-auto px-4 py-4 sm:px-5 sm:py-5",
})``;

export const ModalSectionBodySecondary = styled.div.attrs({
  className: "border-t border-[var(--brand-border)] px-4 py-4 sm:px-5",
})``;

const modalWidthClassNames = {
  md: "max-w-xl",
  lg: "max-w-4xl",
} as const;

export const ModalOverlayMotionButton = styled(motion.button).attrs({
  className: "fixed inset-0 z-[90] bg-[rgba(4,6,9,0.72)] backdrop-blur-sm",
})``;

export const ModalMotionPanel = styled(motion.div).attrs<{
  $size: keyof typeof modalWidthClassNames;
}>(({ $size }) => ({
  className: `brand-panel relative flex max-h-[88vh] w-full flex-col overflow-hidden ${modalWidthClassNames[$size]}`,
}))`` as any;
